import { API } from "../axios/API";


const getContribuyentes = async (data) => {
  try {
    let response = await API.post("/contribuyentes", data);

    if (response.data?.mensaje) return response.data?.mensaje;

    return response.data;
  }
  catch (error) {
    return "error";
  }
};

const getContribuyente = async (id) => {
  try {
    let response = await API.get(`/contribuyentes/${id}`);

    return response.data;
  }
  catch (err) {
    return err.message;
  }
};

const createContribuyente = async (data) => {
  try {
    let newData = new FormData();

    for (const prop in data) {
      if (prop === "inmuebles") {
        data[prop].forEach((e) => {
          if (e.documentos?.length) {
            e.documentos.forEach((file) => {

              newData.append(`file_${e.inmueble}${e.recurso}`, file.originFileObj);
            });
          }
        });

        newData.append("inmuebles", JSON.stringify(data[prop].map((e) => {
          const { inmueble, recurso, observaciones, caracter } = e;

          return {
            inmueble, recurso, observaciones, caracter
          };
        })));
      }
      else {
        if (data[prop]) {
          newData.append(`${prop}`, data[prop]);
        }
      }
    }
    const response = await API.post("/contribuyentes/create", newData);

    return response.data;
  }
  catch (err) {
    return err;
  }
};

const saveContribuyente = async (data) => {
  try {
    let newData = new FormData();

    for (const prop in data) {
      if (prop === "inmuebles") {
        data[prop].forEach((e) => {
          if (e.documentos?.length) {
            e.documentos.forEach((file) => {

              newData.append(`file_${e.inmueble}${e.recurso}`, file.originFileObj);
            });
          }
        });

        newData.append("inmuebles", JSON.stringify(data[prop].map((e) => {
          const { inmueble, recurso, observaciones, caracter } = e;

          return {
            inmueble, recurso, observaciones, caracter
          };
        })));
      }
      else {
        if (data[prop]) {
          newData.append(`${prop}`, data[prop]);
        }
      }
    }
    const response = await API.post("/contribuyentes/save", newData);

    return response.data;
  }
  catch (err) {
    return err;
  }
};

const editContribuyente = async (id) => {
  try {
    let response = await API.get(`/contribuyentes/${id}`);

    return response.data;
  }
  catch (err) {
    return err.message;
  }
};

const editInmueble = async (data) => {
  try {
    let newData = new FormData();

    if (data.documentos?.length) {
      data.documentos.forEach((file) => {
        newData.append("documentos", file.originFileObj);
      });
    }

    newData.append("inmueble", JSON.stringify({
      id: data.id,
      inmueble: data.inmueble,
      observaciones: data.observaciones,
      caracter: data.caracter
    }));

    const response = await API.put("/contribuyentes/inmueble", newData);

    return response.data;
  }
  catch (err) {
    return err.message;
  }
};

const deleteInmueble = async (id) => {
  try {
    const response = await API.delete(`/contribuyentes/inmueble/${id}`);

    return response.data;
  }
  catch (err) {
    return err.message;
  }
};

const getInmueble = async (id) => {
  try {
    const response = await API.get(`/contribuyentes/inmueble/${id}`);

    return response.data;
  }
  catch (err) {
    return err.message;
  }
};

const deleteDocumento = async (id) => {
  try {
    const response = await API.delete(`/contribuyentes/documento/${id}`);

    return response.data;
  }
  catch (err) {
    return err.message;
  }
};


export const misContribuyenteService = {
  getContribuyentes,
  getContribuyente,
  createContribuyente,
  saveContribuyente,
  editContribuyente,
  editInmueble,
  deleteInmueble,
  getInmueble,
  deleteDocumento
};
